import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { AppSumoPayload } from 'Interfaces/Auth';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: AppSumoPayload) =>
    $actions.user.signInAppSumoUser(dispatch, payload),
  );
};
